import { millisecondsToseconds } from "./utils";

/**
 * Accumulates audio into consecutive, non-overlapping inference windows.
 * @param duration the duration of one window (ms)
 * @param sr sampling frequency
 */
export class CustomAudioBuffer {
  private buffer!: Float32Array;
  private bufferLength!: number;
  private windowLength!: number;
  private sampleRate: number;

  constructor(duration: number, sr: number) {
    this.sampleRate = sr;
    this.setDuration(duration);
  }

  public setDuration(duration: number) {
    // A zero-length window would prevent update() from making progress.
    this.windowLength = Math.max(1, Math.floor(millisecondsToseconds(duration) * this.sampleRate));
    this.buffer = new Float32Array(this.windowLength);
    this.clear();
  }

  public clear() {
    this.bufferLength = 0;
  }

  /** Append samples, emitting each full window once and retaining any incomplete tail. */
  public update(x: Float32Array, callback: (data: Float32Array, sr: number) => void) {
    let offset = 0;
    while (offset < x.length) {
      const free = this.windowLength - this.bufferLength;
      const toCopy = Math.min(free, x.length - offset);
      this.buffer.set(x.subarray(offset, offset + toCopy), this.bufferLength);
      this.bufferLength += toCopy;
      offset += toCopy;

      if (this.bufferLength >= this.windowLength) {
        callback(this.buffer.slice(), this.sampleRate);
        this.bufferLength = 0;
      }
    }
  }
}
